import consultoria from '../../assets/images/inicio/image-consultoria.png'
import desarrollo from '../../assets/images/inicio/image-desarrollo-software.png'
import gestion from '../../assets/images/inicio/image-gestion-productos.png'
import soporte from '../../assets/images/inicio/image-soporte-operaciones.png'
import arquitectura from '../../assets/images/inicio/image-arquitectura.png'
import estrategia from '../../assets/images/inicio/image-estrategia.png'
import adaptabilidad from '../../assets/images/inicio/icon-adaptabilidad.svg'
import apoyo from '../../assets/images/inicio/icon-apoyo.svg'
import experiencia from '../../assets/images/inicio/icon-experiencia.svg'
import soluciones from '../../assets/images/inicio/icon-soluciones.svg'

import logoTifin from '../../assets/images/casosExito/logo-tifin.svg'
import logoEntrenaVirtual from '../../assets/images/casosExito/logo-entrena-virtual.svg'
import logoVikika from '../../assets/images/casosExito/logo-vikika.svg'
import logoRFHE from '../../assets/images/casosExito/logo-rfhe.svg'
import logoArbor from '../../assets/images/casosExito/logo-arbor.svg'
import logoSavso from '../../assets/images/casosExito/logo-savso.svg'
import logoGaia from '../../assets/images/casosExito/logo-gaia.svg'
import logoPella from '../../assets/images/casosExito/logo-pella.svg'
import logoAxis from '../../assets/images/casosExito/logo-axispharma.svg'

// import imagenArbor from '../../assets/images/casosExito/mockup_arbor.png'
// import imagenRFHE from '../../assets/images/casosExito/mockup_rfhe.png'
// import imagenEntrenaVirtual from '../../assets/images/casosExito/mockup_entrena.png'
// import imagenSavso from '../../assets/images/casosExito/mockup_savso.png'
// import logoFUE from '../../assets/images/casosExito/logo-fue.png'
// import imagenGaia from '../../assets/images/casosExito/mockup_gaia.png'
// import imagenPella from '../../assets/images/casosExito/mockup_pella-2.png'
// import imagenAxis from '../../assets/images/casosExito/mockup_axispharma.png'

// import googlePlayImagen from '../../assets/images/casosExito/googleplay.png'
// import appleStoreImagen from '../../assets/images/casosExito/appstore.png'

import alineacion from '../../assets/images/estrategiaIT/icon-alineacion.svg'
import eficiencia from '../../assets/images/estrategiaIT/icon-eficiencia.svg'
import resiliencia from '../../assets/images/estrategiaIT/icon-resiliencia.svg'
import sostenible from '../../assets/images/estrategiaIT/icon-sostenible.svg'

import automatizacion from '../../assets/images/soporteOperaciones/automatizacion.svg'
import gestiondatos from '../../assets/images/soporteOperaciones/gestion.svg'
import integracion from '../../assets/images/soporteOperaciones/integracion.svg'
import transparencia from '../../assets/images/soporteOperaciones/transparencia.svg'
import reduccion from '../../assets/images/soporteOperaciones/reduccion.svg'
import agilidad from '../../assets/images/soporteOperaciones/agilidad.svg'
import comunicacion from '../../assets/images/soporteOperaciones/comunicacion.svg'
import escalabilidad from '../../assets/images/soporteOperaciones/escalabilidad.svg'

import arquitecturaimg from '../../assets/images/arquitecturaSoftware/arquitecutra.svg'
import diseno from '../../assets/images/arquitecturaSoftware/diseno.svg'
import evolutiva from '../../assets/images/arquitecturaSoftware/evolutiva.svg'
import infraestructura from '../../assets/images/arquitecturaSoftware/infraestructura.svg'
import integracionimg from '../../assets/images/arquitecturaSoftware/integracion.svg'
import observabilidad from '../../assets/images/arquitecturaSoftware/observabilidad.svg'
import seguridad from '../../assets/images/arquitecturaSoftware/seguridad.svg'
import seleccion from '../../assets/images/arquitecturaSoftware/seleccion.svg'

// import bannerDesarrollo from '../../assets/images/desarrolloSoftware/bannerDesarrollo.svg'
import icon1 from '../../assets/images/desarrolloSoftware/Icon1.svg'
import icon2 from '../../assets/images/desarrolloSoftware/Icon2.svg'
import icon3 from '../../assets/images/desarrolloSoftware/Icon3.svg'
import icon4 from '../../assets/images/desarrolloSoftware/Icon4.svg'

import cloud from '../../assets/images/desarrolloSoftware/cloud.svg'
import diversity_3 from '../../assets/images/desarrolloSoftware/diversity_3.svg'
import language from '../../assets/images/desarrolloSoftware/language.svg'
import phonelink from '../../assets/images/desarrolloSoftware/phonelink.svg'
import security from '../../assets/images/desarrolloSoftware/security.svg'
import trending_up from '../../assets/images/desarrolloSoftware/trending_up.svg'

import start from '../../assets/images/gestionproductos/radar.svg'
import design from '../../assets/images/gestionproductos/push_pin.svg'
import align from '../../assets/images/gestionproductos/groups_2.svg'
import validate from '../../assets/images/gestionproductos/create.svg'
import execute from '../../assets/images/gestionproductos/rocket_launch.svg'
import measure from '../../assets/images/gestionproductos/equalizer.svg'

const razones =
[
  {
    icono: soluciones,
    titulo: 'Soluciones Prácticas',
    texto: 'Ofrecemos soluciones que se adaptan a tu negocio, priorizando la practicidad para simplificar tus operaciones diarias.'
  },
  {
    icono: experiencia,
    titulo: 'Experiencia Confiable',
    texto: 'Con 10+ años de experiencia, hemos aprendido lo que realmente importa. Nuestra trayectoria habla por sí misma.'
  },
  {
    icono: adaptabilidad,
    titulo: 'Adaptabilidad a tu medida',
    texto: 'Creemos en la flexibilidad. Nuestro software se adapta a tus necesidades, no al revés. Personalización real para empresas reales.'
  },
  {
    icono: apoyo,
    titulo: 'Apoyo Genuino',
    texto: 'Nuestro compromiso va más allá del software. Estamos aquí para brindarte un apoyo genuino en cada paso, porque tu éxito es el nuestro.'
  }
]
const servicios =
[
  {
    imagen: consultoria,
    titulo: 'Consultoría',
    texto: 'Navegamos justos hacia soluciones empresariales.',
    textoBoton: 'Explora soluciones estratégicas',
    ruta: 'consultoria'
  },
  {
    imagen: desarrollo,
    titulo: 'Desarrollo de Software',
    texto: 'Codigo creativo, soluciones sorprendentes',
    textoBoton: 'Haz realidad tus ideas',
    ruta: 'desarrollo-software'
  },
  {
    imagen: gestion,
    titulo: 'Gestión de productos',
    texto: 'De la idea al éxito: gestionamos, optimizamos, triunfamos',
    textoBoton: 'Potencia tus productos',
    ruta: 'gestion-de-productos'
  },
  {
    imagen: soporte,
    titulo: 'Soporte de operaciones',
    texto: 'Operaciones fluyendo sin obstáculos, siempre',
    textoBoton: 'Optimizar operaciones',
    ruta: 'soporte-de-operaciones'
  },
  {
    imagen: arquitectura,
    titulo: 'Arquitectura de Software',
    texto: 'Construyendo bases sólidas',
    textoBoton: 'Descubre nuestras soluciones de arquitectura',
    ruta: 'arquitectura'
  },
  {
    imagen: estrategia,
    titulo: 'Estrategia TI',
    texto: 'Construyendo estrategias digitales para el futuro',
    textoBoton: 'Descubre tu estrategia TI',
    ruta: 'estrategia-it'
  }
]

const casosexito =
[
  {
    logos: [logoTifin],
    nombre: 'Tifin',
    urls: ['https://tifin.com/'],
    texto: 'TIFIN es una empresa estadounidense especializada en bienestar financiero. Desarrollamos su plataforma TIFIN @Work, una solución conversacional impulsada por inteligencia artificial que brinda asesoramiento financiero personalizado a empleados. Seguimos colaborando en este y otros proyectos para mejorar la accesibilidad y eficiencia de sus servicios.'
  },
  {
    logos: [logoEntrenaVirtual],
    nombre: 'Entrena Virtual',
    urls: ['https://www.entrenavirtual.es/app'],
    texto: 'Criterian brindó consultoría estratégica a Entrenavirtual, enfocándose en la gestión interna y la organización del equipo. Nuestro análisis detallado les ayudó a optimizar su estructura y definir un camino sólido en la industria del bienestar.'
  },
  {
    logos: [logoVikika],
    nombre: 'Vikika Team',
    urls: ['https://vikika.es/'],
    texto: 'Vikika Team, liderado por Verónica Costa, ofrece planes de nutrición y entrenamiento. Nos encargamos del rediseño de su web y la optimización de su funcionalidad interna para mejorar la experiencia del usuario.'
  },
  {
    logos: [logoRFHE],
    nombre: 'Real Federación Hípica Española',
    urls: ['https://www.rfhe.com'],
    texto: 'Lideramos el desarrollo de la aplicación y la mejora de la accesibilidad web de la Real Federación Hípica Española (RFHE), creando una experiencia más inclusiva para personas con diversidad funcional.'
  },
  {
    logos: [logoArbor],
    nombre: 'Arbor',
    urls: ['https://www.arborfintech.com'],
    texto: 'En Criterian, desarrollamos la presencia online y la app móvil de Arbor, materializando su visión de salud financiera. Creamos una plataforma que ofrece educación financiera, ahorro, inversión y préstamos transparentes.'
  },
  {
    logos: [logoSavso],
    nombre: 'Savso',
    urls: ['https://www.savso.es'],
    texto: 'Savso es una empresa especializada en minicréditos y préstamos rápidos en línea, con montos entre 100€ y 900€ y devoluciones semanales. Desarrollamos una plataforma integral que incluye el portal del cliente y el back-office, optimizando la gestión de sus servicios financieros.'
  },
  {
    logos: [logoGaia],
    nombre: 'Gaia Program',
    urls: ['https://www.gaianext.com', 'https://www.bridgenext.es'],
    texto: 'Gaia es una empresa dedicada a la oferta de másteres online. Colaboramos en el desarrollo del software para su plataforma educativa, facilitando una experiencia de aprendizaje en línea óptima y accesible para sus estudiantes.'
  },
  {
    logos: [logoPella],
    nombre: 'Pella',
    urls: ['https://pellaathletika.com/'],
    texto: 'Pella es una aplicación enfocada en el entrenamiento físico. Participamos en su desarrollo, creando una herramienta intuitiva y funcional que permite a los usuarios planificar y seguir sus rutinas de ejercicio de manera efectiva'
  },
  {
    logos: [logoAxis],
    nombre: 'Axis Pharma',
    urls: ['https://es.axispharma.com/'],
    texto: 'Axis Pharma es una consultora estratégica líder en el sector farmacéutico y biotecnológico, con más de 20 años de experiencia. Desarrollamos una plataforma que optimiza la recolección y gestión de datos clave para sus estudios médicos, mejorando la eficiencia y facilitando la toma de decisiones estratégicas.'
  }
]

const valores =
[
  {
    titulo: 'Colaboración',
    texto: 'Trabajamos en conjunto hacia metas comunes, reconociendo que el éxito individual de cada miembro contribuye al éxito colectivo de Criterian.'
  },
  {
    titulo: 'Integridad',
    texto: 'Actuamos con integridad y decimos lo que pensamos. Nos comprometemos a ser honestos y transparentes en todas nuestras interacciones, creando una base sólida para relaciones personales y profesionales.'
  },
  {
    titulo: 'Apertura',
    texto: 'Nos mantenemos abiertos a nuevas ideas y perspectivas, alentando la diversidad de opiniones y no temiendo el desacuerdo mientras buscamos alcanzar un consenso.'
  },
  {
    titulo: 'Responsabilidad',
    texto: 'Asumimos la responsabilidad de nuestras decisiones y de las consecuencias que puedan derivarse de ellas, construyendo una cultura de confianza y confiabilidad.'
  },
  {
    titulo: 'Excelencia',
    texto: 'Seguimos estándares de calidad excepcionales en todo lo que hacemos y nos esforzamos por la mejora continua, impulsados por el deseo de superar las expectativas.'
  },
  {
    titulo: 'Respeto',
    texto: 'Escuchamos a nuestros colegas como profesionales, fomentando un ambiente donde se respeta la diversidad y se valora a cada individuo como ser humano.'
  }
]
const nuestroTrabajo =
[
  {
    titulo: 'Consulta Personalizada',
    texto: 'Nos sumergimos en una consulta personalizada, sentándonos contigo para comprender en profundidad tus objetivos empresariales y desafíos únicos. Este diálogo nos permite establecer una base sólida para el trabajo conjunto.'
  },
  {
    titulo: 'Análisis Detallado',
    texto: 'Realizamos un análisis exhaustivo de tu infraestructura actual, utilizando herramientas avanzadas y expertise técnico. Este proceso nos permite identificar oportunidades de mejora y proponer soluciones personalizadas.'
  },
  {
    titulo: 'Planificación Estratégica',
    texto: 'Basándonos en los resultados del análisis, desarrollamos una planificación estratégica detallada. Este plan está meticulosamente adaptado a tus necesidades específicas, asegurando una hoja de ruta clara y efectiva para alcanzar tus metas.'
  },
  {
    titulo: 'Implementación',
    texto: 'Pasamos de la planificación a la acción, implementando la estrategia con eficiencia y precisión. Nuestro enfoque está respaldado por profesionales altamente capacitados y herramientas tecnológicas de vanguardia para garantizar resultados tangibles y duraderos.'
  },
  {
    titulo: 'Seguimiento y ajustes continuos',
    texto: 'Después de la implementación, no dejamos nada al azar. Realizamos evaluaciones periódicas para medir el rendimiento y realizar ajustes continuos según sea necesario. Este ciclo de mejora constante garantiza que nuestra colaboración evolucione con tu empresa.'
  }
]
const descripcionBeneficios =
[
  {
    titulo: '',
    texto: 'Nuestra Estrategia TI se enfoca en comprender tus objetivos empresariales y alinearlos con soluciones tecnológicas efectivas. A través de un análisis exhaustivo, identificamos oportunidades de mejora, optimización de recursos y fortalecimiento de la infraestructura tecnológica.'
  }
]
const beneficios =
[
  {
    icono: alineacion,
    titulo: 'Alineación con objetivos',
    texto: 'Integración de tecnología para potenciar tus metas comerciales.'
  },
  {
    icono: eficiencia,
    titulo: 'Eficiencia Operativa',
    texto: 'Optimización de procesos y recursos digitales.'
  },
  {
    icono: resiliencia,
    titulo: 'Resiliencia Tecnológica',
    texto: 'Preparación para los desafíos futuros del mundo digital.'
  },
  {
    icono: sostenible,
    titulo: 'Innovación Sostenible',
    texto: 'Impulso constante hacia nuevas oportunidades tecnológicas.'
  }
]

const operaciones =
[
  {
    icono: automatizacion,
    titulo: 'Automatización de Procesos',
    texto: 'Optimiza procesos y reduce errores mediante la automatización de tareas.'
  },
  {
    icono: gestiondatos,
    titulo: 'Gestión Eficiente de Datos',
    texto: 'Transforma tus datos en información útil para una toma de decisiones estratégica.'
  },
  {
    icono: escalabilidad,
    titulo: 'Escalabilidad de Operaciones',
    texto: 'Adapta y expande tus procesos fácilmente conforme crece tu empresa.'
  },
  {
    icono: integracion,
    titulo: 'Integración de Sistemas',
    texto: 'Conecta herramientas y equipos para una colaboración fluida y sin interrupciones.'
  },
  {
    icono: transparencia,
    titulo: 'Transparencia Operativa',
    texto: 'Obtén visibilidad total de los procesos para una gestión más efectiva.'
  },
  {
    icono: reduccion,
    titulo: 'Reducción de Redundancias',
    texto: 'Elimina tareas duplicadas y optimiza el uso de tus recursos disponibles.'
  },
  {
    icono: agilidad,
    titulo: 'Agilidad en Decisiones',
    texto: 'Toma decisiones más rápidas con información clara y actualizada.'
  },
  {
    icono: comunicacion,
    titulo: 'Comunicación Eficiente',
    texto: 'Mejora la coordinación entre equipos con canales claros y estructurados.'
  }
]
const arquitecturasofware =
[
  {
    icono: arquitecturaimg,
    titulo: 'Arquitectura adaptativa',
    texto: 'Tu negocio evoluciona, tu sistema también. ',
    subtexto: 'Diseñamos sistemas preparados para el cambio: nuevos módulos, nuevos equipos, nuevos retos. Nada rígido, todo pensado para adaptarse.'
  },
  {
    icono: diseno,
    titulo: 'Diseño basado en dominio',
    texto: 'La tecnología al servicio del negocio',
    subtexto: 'Trabajamos con modelos que reflejan tu realidad operativa. Usamos DDD (Domain-Driven Design) para que la arquitectura hable el mismo idioma que tu empresa.'

  },
  {
    icono: seleccion,
    titulo: 'Selección tecnológica estratégica',
    texto: 'Cada decisión importa',
    subtexto: 'Desde bases de datos y lenguajes hasta estilos arquitectónicos (monolito modular, microservicios, event-driven, etc.), cada tecnología se elige con criterio técnico y visión de futuro.'

  },
  {
    icono: integracionimg,
    titulo: 'Integraciones pensadas, no improvisadas',
    texto: 'Conexiones limpias y mantenibles',
    subtexto: 'Diseñamos la arquitectura pensando en la interoperabilidad: APIs bien definidas, eventos claros, sistemas desacoplados. Nada de acoplamientos frágiles que se rompen al menor cambio.'

  },
  {
    icono: infraestructura,
    titulo: 'Infraestructura como parte del diseño',
    texto: 'Cloud-ready desde la base',
    subtexto: 'No “movemos” a la nube: diseñamos para ella. Arquitecturas pensadas para escalar, auto-recuperarse y desplegarse de forma automatizada en cualquier entorno cloud.'

  },
  {
    icono: seguridad,
    titulo: 'Seguridad estructural',
    texto: 'La seguridad no se añade después, se diseña desde el inicio',
    subtexto: 'Manejamos identidades, accesos, datos y comunicaciones desde una perspectiva arquitectónica. Aplicamos principios de defensa en profundidad desde la base.'

  },
  {
    icono: observabilidad,
    titulo: 'Observabilidad y control',
    texto: 'Diseñamos para entender el sistema, no solo para usarlo',
    subtexto: 'Log centralizado, trazabilidad, monitoreo y alertas no son “extras”: son parte de la arquitectura. Porque lo que no se ve, no se puede mejorar.'

  },
  {
    icono: evolutiva,
    titulo: 'Evolutiva por diseño',
    texto: 'Mantenible, escalable y lista para crecer',
    subtexto: 'Evitamos decisiones técnicas que se vuelven deuda mañana. Pensamos en la evolución desde el primer diagrama, no como una fase futura.'

  }
]
const proceso =
[
  {
    icono: icon1,
    titulo: 'Análisis Técnico',
    texto: 'Entendemos las necesidades funcionales y técnicas del proyecto. Identificamos los requisitos de rendimiento, seguridad, escalabilidad y mantenibilidad desde el inicio'
  },
  {
    icono: icon2,
    titulo: 'Diseño de Arquitectura',
    texto: 'Definimos la estructura técnica del sistema: componentes, flujos de datos, servicios y tecnologías clave. Priorizamos una arquitectura limpia, modular y escalable.'
  },
  {
    icono: icon3,
    titulo: 'Desarrollo Iterativo',
    texto: 'Construimos el sistema en fases, asegurando calidad en cada entrega. Aplicamos buenas prácticas de codificación, control de versiones y pruebas.'
  },
  {
    icono: icon4,
    titulo: 'Despliegue y evolución',
    texto: 'Automatizamos el despliegue y dejamos el proyecto preparado para evolucionar. Documentamos decisiones técnicas y apoyamos el crecimiento continuo del software.'
  }
]
const descripcionProceso =
[
  {
    titulo: '',
    texto: 'En Criterian, el desarrollo de una web, app o plataforma empieza con una arquitectura bien definida. No improvisamos: analizamos las necesidades del proyecto y diseñamos una estructura técnica clara, coherente y adaptada al crecimiento del producto.'
  }
]
const listaComponentes =
[
  {
    icono: trending_up,
    titulo: 'Arquitectura Escalable',
    texto: 'Diseñamos estructuras técnicas preparadas para crecer sin romperse. Desde MVPs hasta plataformas complejas, construimos pensando en el futuro del producto.'
  },
  {
    icono: language,
    titulo: 'Webs y APIs bien conectadas',
    texto: 'Realizamos un análisis exhaustivo de tu infraestructura actual, utilizando herramientas avanzadas y expertise técnico. Este proceso nos permite identificar oportunidades de mejora y proponer soluciones personalizadas.'
  },
  {
    icono: phonelink,
    titulo: 'Experiencia multiplataforma',
    texto: 'Basándonos en los resultados del análisis, desarrollamos una planificación estratégica detallada. Este plan está meticulosamente adaptado a tus necesidades específicas, asegurando una hoja de ruta clara y efectiva para alcanzar tus metas.'
  },
  {
    icono: cloud,
    titulo: 'Listo para la nube',
    texto: 'Pasamos de la planificación a la acción, implementando la estrategia con eficiencia y precisión. Nuestro enfoque está respaldado por profesionales altamente capacitados y herramientas tecnológicas de vanguardia para garantizar resultados tangibles y duraderos.'
  },
  {
    icono: security,
    titulo: 'Seguridad integrada',
    texto: 'Después de la implementación, no dejamos nada al azar. Realizamos evaluaciones periódicas para medir el rendimiento y realizar ajustes continuos según sea necesario. Este ciclo de mejora constante garantiza que nuestra colaboración evolucione con tu empresa.'
  },
  {
    icono: diversity_3,
    titulo: 'Código mantenible',
    texto: 'Escribimos código limpio, estructurado y documentado. Esto facilita futuras evoluciones, nuevos equipos o mejoras continuas sin sobrecostes.'
  }
]
const enfoque = [
  {
    icono: start,
    titulo: 'Empezar con intención',
    texto: 'Todo gran producto nace con un "por qué" sólido. Antes de hablar de features, entendemos qué problema vale la pena resolver y cuál es el valor que genera resolverlo.'
  },
  {
    icono: design,
    titulo: 'Diseñar una estrategia, no usa lista de funcionalidades',
    texto: 'Ayudamos a traducir visión en objetivos, y objetivos en decisiones. Creamos una hoja de ruta que sirve para avanzar, no para atarse. Lo importante: priorizar con impacto.'
  },
  {
    icono: align,
    titulo: 'Alinear personas, no solo procesos',
    texto: 'Un buen producto necesita equipo, no solo herramientas. Facilitamos colaboración real entre negocio, diseño y desarrollo. Todos reman hacia el mismo lugar.'
  },
  {
    icono: validate,
    titulo: 'Validar antes de construir',
    texto: 'Prototipar, testear, entrevistar, medir: usamos el método más adecuado para saber si lo que queremos hacer... vale la pena hacerlo. Lo demás, se descarta sin culpa.'
  },
  {
    icono: execute,
    titulo: 'Ejecutar con foco',
    texto: 'La gestión de producto no es solo discovery. Acompañamos cada etapa del deliveru, cuidando la calidad, los tiempos y el objetivo final. Ejecutar bien también es una decisión estratégica.'
  },
  {
    icono: measure,
    titulo: 'Medir para evolucionar',
    texto: 'Despues del primer lanzamiento, empieza el trabajo de verdad: iterar, analizar, optimizar. Un buen producto siempre está aprendiendo de sus usuarios.'
  }
]

export default { servicios, razones, valores, nuestroTrabajo, descripcionBeneficios, beneficios, casosexito, operaciones, arquitecturasofware, proceso, descripcionProceso, listaComponentes, enfoque }
